// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zzd52ypIZJCeR7 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.DJk5G36WUSaf16 {\n  width: unset;\n}\n.ikRSpaZzSWpTOp {\n  width: 200px;\n  z-index: 10;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": "zzd52ypIZJCeR7",
	"boardCard": "DJk5G36WUSaf16",
	"searchCard": "ikRSpaZzSWpTOp"
};
export default ___CSS_LOADER_EXPORT___;
